import React, { useState } from 'react';
import AdminLayout from '../../components/AdminLayout/AdminLayout';
import './AdminAdsManagePage.css';

const AdminAdsManagePage = () => {
  const [activeTab, setActiveTab] = useState('active');

  const adsPlacements = [
    { id: 1, name: 'Homepage Hero Banner', price: '$500/month', dimensions: '1920x600px', status: 'Active', views: '45,230', clicks: '2,340' },
    { id: 2, name: 'Sidebar Banner', price: '$200/month', dimensions: '300x600px', status: 'Active', views: '32,150', clicks: '1,820' },
    { id: 3, name: 'Category Page Top', price: '$350/month', dimensions: '728x90px', status: 'Active', views: '28,900', clicks: '1,560' },
    { id: 4, name: 'Product Listing Sponsor', price: '$150/month', dimensions: '300x250px', status: 'Inactive', views: '0', clicks: '0' },
    { id: 5, name: 'Footer Banner', price: '$100/month', dimensions: '728x90px', status: 'Active', views: '18,450', clicks: '890' },
  ];

  const activeAds = [
    { id: 1, company: 'ABC Steel Works', placement: 'Homepage Hero', startDate: '2025-01-01', endDate: '2025-03-01', amount: '$1,500', status: 'Running' },
    { id: 2, company: 'BuildRight Materials', placement: 'Sidebar Banner', startDate: '2025-01-15', endDate: '2025-02-15', amount: '$200', status: 'Running' },
    { id: 3, company: 'Concrete Plus Ltd', placement: 'Category Page Top', startDate: '2025-01-10', endDate: '2025-04-10', amount: '$1,050', status: 'Running' },
    { id: 4, company: 'Gulf Paints Co', placement: 'Footer Banner', startDate: '2024-12-01', endDate: '2025-01-31', amount: '$200', status: 'Ending Soon' },
  ];

  const getStatusClass = (status) => {
    switch (status) {
      case 'Active':
      case 'Running': return 'status-active';
      case 'Inactive': return 'status-inactive';
      case 'Ending Soon': return 'status-warning';
      default: return '';
    }
  };

  return (
    <AdminLayout>
      <div className="admin-ads-content">
        <div className="ads-page-header">
          <div className="ads-title-section">
            <h1 className="ads-page-title">Ads & Promotions</h1>
            <p className="ads-page-description">Manage advertising placements and promotional campaigns</p>
          </div>
          <button className="add-placement-btn">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Add Placement
          </button>
        </div>

        {/* Stats Cards */}
        <div className="ads-stats-grid">
          <div className="ads-stat-card">
            <div className="stat-icon revenue">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="stat-info">
              <div className="stat-value">$12,450</div>
              <div className="stat-label">Total Revenue</div>
            </div>
          </div>
          <div className="ads-stat-card">
            <div className="stat-icon active">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="stat-info">
              <div className="stat-value">8</div>
              <div className="stat-label">Active Ads</div>
            </div>
          </div>
          <div className="ads-stat-card">
            <div className="stat-icon views">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="stat-info">
              <div className="stat-value">124K</div>
              <div className="stat-label">Total Views</div>
            </div>
          </div>
          <div className="ads-stat-card">
            <div className="stat-icon clicks">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="stat-info">
              <div className="stat-value">6.5K</div>
              <div className="stat-label">Total Clicks</div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="ads-tabs">
          <button 
            className={`ads-tab ${activeTab === 'active' ? 'active' : ''}`}
            onClick={() => setActiveTab('active')}
          >
            Active Campaigns
          </button>
          <button 
            className={`ads-tab ${activeTab === 'placements' ? 'active' : ''}`}
            onClick={() => setActiveTab('placements')}
          >
            Ad Placements
          </button>
        </div>

        {/* Active Ads Tab */}
        {activeTab === 'active' && (
          <div className="ads-table-container">
            <table className="ads-table">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Placement</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {activeAds.map((ad) => (
                  <tr key={ad.id}>
                    <td className="company-name">{ad.company}</td>
                    <td>{ad.placement}</td>
                    <td>{ad.startDate}</td>
                    <td>{ad.endDate}</td>
                    <td className="amount">{ad.amount}</td>
                    <td>
                      <span className={`status-badge ${getStatusClass(ad.status)}`}>
                        {ad.status}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button className="action-btn view-btn" title="View">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M1 8C1 8 3.5 3 8 3C12.5 3 15 8 15 8C15 8 12.5 13 8 13C3.5 13 1 8 1 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </button>
                        <button className="action-btn edit-btn" title="Edit">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Placements Tab */}
        {activeTab === 'placements' && (
          <div className="placements-grid">
            {adsPlacements.map((placement) => (
              <div key={placement.id} className="placement-card">
                <div className="placement-header">
                  <h3 className="placement-name">{placement.name}</h3>
                  <span className={`placement-status ${getStatusClass(placement.status)}`}>
                    {placement.status}
                  </span>
                </div>
                <div className="placement-details">
                  <div className="detail-row">
                    <span className="detail-label">Price:</span>
                    <span className="detail-value price">{placement.price}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Dimensions:</span>
                    <span className="detail-value">{placement.dimensions}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Views:</span>
                    <span className="detail-value">{placement.views}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Clicks:</span>
                    <span className="detail-value">{placement.clicks}</span>
                  </div>
                </div>
                <div className="placement-actions">
                  <button className="edit-placement-btn">Edit</button>
                  <button className="preview-placement-btn">Preview</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminAdsManagePage;
